import React from 'react';
import './Status.css';

export const STATUS_TONES = Object.freeze({
  GOOD: 'good',
  WATCH: 'watch',
  BEHIND: 'behind',
  NEUTRAL: 'neutral'
});

const TONE_ALIASES = {
  active: STATUS_TONES.GOOD,
  approved: STATUS_TONES.GOOD,
  ahead: STATUS_TONES.GOOD,
  good: STATUS_TONES.GOOD,
  linked: STATUS_TONES.GOOD,
  success: STATUS_TONES.GOOD,

  fair: STATUS_TONES.WATCH,
  needs_link: STATUS_TONES.WATCH,
  'needs-link': STATUS_TONES.WATCH,
  on_track: STATUS_TONES.WATCH,
  partial: STATUS_TONES.WATCH,
  pending: STATUS_TONES.WATCH,
  returned: STATUS_TONES.WATCH,
  warn: STATUS_TONES.WATCH,
  warning: STATUS_TONES.WATCH,
  watch: STATUS_TONES.WATCH,

  behind: STATUS_TONES.BEHIND,
  critical: STATUS_TONES.BEHIND,
  danger: STATUS_TONES.BEHIND,
  denied: STATUS_TONES.BEHIND,
  inactive: STATUS_TONES.BEHIND,
  rejected: STATUS_TONES.BEHIND,

  draft: STATUS_TONES.NEUTRAL,
  info: STATUS_TONES.NEUTRAL,
  neutral: STATUS_TONES.NEUTRAL,
  no_data: STATUS_TONES.NEUTRAL,
  'not-required': STATUS_TONES.NEUTRAL,
  not_required: STATUS_TONES.NEUTRAL
};

export function normalizeStatusTone(tone = STATUS_TONES.NEUTRAL) {
  const key = String(tone || '').trim().toLowerCase();
  return TONE_ALIASES[key] || STATUS_TONES.NEUTRAL;
}

export function StatusPill({ tone = STATUS_TONES.NEUTRAL, children, className = '', ...props }) {
  const normalizedTone = normalizeStatusTone(tone);
  return (
    <span className={`status-pill status-pill--${normalizedTone} ${className}`.trim()} {...props}>
      {children}
    </span>
  );
}

export function StatusStripe({ tone = STATUS_TONES.NEUTRAL, className = '', ...props }) {
  const normalizedTone = normalizeStatusTone(tone);
  return (
    <span className={`status-stripe status-stripe--${normalizedTone} ${className}`.trim()} {...props} />
  );
}

export function StatusDot({ tone = STATUS_TONES.NEUTRAL, size = 'md', pulse = false, className = '', ...props }) {
  const normalizedTone = normalizeStatusTone(tone);
  return (
    <span
      className={`status-dot status-dot--${normalizedTone} status-dot--${size} ${pulse ? 'status-dot--pulse' : ''} ${className}`.trim()}
      {...props}
    />
  );
}
